export default class ShaderData {
	public shader_ScanFeet_Frag() {
		return (
			'#extension GL_OES_standard_derivatives : enable\n' +
			'precision lowp float;\n' +
			'uniform float time, opacity, timeViewMask, widthViewMask, freqViewMask, lineWidth;\n' +
			'uniform vec3 colorOut, colorIn, colorLines, colorOutline, lineDensity;\n' +
			'varying vec3 vNormal, vPosition, vViewPosition;\n' +
			'uniform bool linesMode;\n' +
			'\n' +
			'void main()\n' +
			'{\n' +
			'\t//variable wannabe\n' +
			'\tvec3 timeScale = vec3(0.1);\n' +
			'\tfloat scaleFix = 100.0;\n' +
			'\n' +
			'\t\t//colorFill\n' +
			'\tvec3 viewPos = normalize(-vViewPosition.xyz);\n' +
			'\tfloat colorMix = clamp(dot(vNormal + vec3(0.5, -1.1, 0.0), viewPos),0.0, 1.0);\n' +
			'\tvec3 colorFill = mix(colorOut, colorIn, colorMix);\n' +
			'\tvec3 vPositionFix = vPosition;\n' +
			'\t\tif (linesMode) vPositionFix = vec3(vPositionFix.y, vPositionFix.z, vPositionFix.x) / scaleFix;\n' +
			'\n' +
			'\t//lines grid\n' +
			'\tvec3 gridScale = vPositionFix;\n' +
			'\tgridScale.y = dot(gridScale.z + 1.0, gridScale.y - 1.0) * 0.2;\n' +
			'\tgridScale.z = dot(gridScale.x + 1.0, gridScale.z + 1.0);\n' +
			'\n' +
			'\t//isolines\n' +
			'\tvec3 den = abs(fract (gridScale * lineDensity + time * timeScale) - 0.5);\n' +
			'\tvec3 width = fwidth(gridScale * lineDensity);\n' +
			'\tfloat w1 = max(0.0, lineWidth - 1.0); \n' +
			'\tfloat w2 = max(1.0, lineWidth);\n' +
			'\tvec3 grid = clamp((den - width * w1) / width * (w2 - w1), max(0.0, 1.0 - lineWidth), 1.0);\n' +
			'\n' +
			'\t//opacity\n' +
			'\tfloat xyMask = dot(vPositionFix.z, vPositionFix.y);\n' +
			'\tfloat xyMaskFinal = clamp((abs(fract(xyMask * freqViewMask - time * timeViewMask) - 0.5) * 2.0) * widthViewMask, 0.0, 1.0);\n' +
			'\tfloat alphaSetup = (xyMask - 0.5 + opacity * 4.0);\n' +
			'\tfloat alphaMask = 1.0 - step(alphaSetup, 0.5);\n' +
			'\tfloat alphaMaskGlow = clamp(1.0 - abs(alphaSetup - 0.5) * 4.0, 0.0, 1.0) * 0.3;\n' +
			'\t\tif(alphaMask < 0.01) discard;\n' +
			'\n' +
			'\t//linesGrid color\n' +
			'\tfloat linesMix = 1.0 - clamp (grid.y * grid.z, 0.0, 1.);\n' +
			'\tvec3 linesFinal = mix(vec3(0.0), colorLines, linesMix * clamp((1.0 - xyMaskFinal * 1.5) + (alphaMaskGlow * 5.0), 0.0, 1.0));\n' +
			'\n' +
			'\t//fakeRimLight\n' +
			'\tfloat rimOutline = 1.0 - clamp(dot(vNormal, viewPos) * 2.7, 0.0, 1.0);\n' +
			'\tfloat blik = clamp(dot(vNormal, viewPos) - 0.95, 0.0, 1.0);\n' +
			'\n' +
			'\t//mix all\n' +
			'\tvec3 colorFillGradient= mix(colorLines, vec3(0.0), xyMaskFinal);\n' +
			'\tvec3 mixFinalColorF = clamp(linesFinal + colorFill + blik + rimOutline + colorFillGradient + alphaMaskGlow, 0.0, 1.0);\n' +
			'\tvec3 mixFinalColorB = clamp(linesMix * 0.2 + colorFill + blik + colorFillGradient + alphaMaskGlow, 0.0, 1.0);\n' +
			'\t\t\n' +
			'\t\tif (gl_FrontFacing) {\n' +
			'\t\t\tgl_FragColor = vec4(vec3(mixFinalColorF), 1.0);\n' +
			'\t\t} else {\n' +
			'\t\t\tgl_FragColor = vec4(vec3(mixFinalColorB), 1.0);\n' +
			'\t\t}\n' +
			'}'
		);
	}

	public shader_scanFeet_Vert() {
		return (
			'precision lowp float;\n' +
			'varying vec3 vNormal, vPosition, vViewPosition;\n' +
			'uniform bool linesMode;\n' +
			'\n' +
			'void main()\n' +
			'{\n' +
			'\tvNormal = normalize(normalMatrix * normal);\n' +
			'\tvPosition = position;\n' +
			'\tvViewPosition = (modelViewMatrix * vec4(position, 1.0)).xyz;\n' +
			'\n' +
			'\tgl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n' +
			'}'
		);
	}

	public shader_scanOutline_Frag() {
		return (
			'#extension GL_OES_standard_derivatives : enable\n' +
			'precision lowp float;\n' +
			'uniform float opacity;\n' +
			'uniform vec3 colorOutline;\n' +
			'varying vec3 vNormal, vPosition, vViewPosition;\n' +
			'uniform bool linesMode;\n' +
			'\n' +
			'void main()\n' +
			'{\n' +
			'\tfloat scaleFix = 100.0;\n' +
			'\tvec3 vPositionFix = vPosition;\n' +
			'\t\tif (linesMode) vPositionFix = vec3(vPositionFix.y, vPositionFix.z, vPositionFix.x) / scaleFix;\n' +
			'\n' +
			'\tfloat xyMask = dot(vPositionFix.z, vPositionFix.y);\n' +
			'\tfloat alphaSetup = (xyMask - 0.5 + opacity * 2.5);\n' +
			'\tfloat alphaMask = 1.0 - step(alphaSetup, 0.5);\n' +
			'\t\tif(alphaMask < 0.01)\n' +
			'\t\tdiscard;\n' +
			'\n' +
			'\tgl_FragColor = vec4(vec3(colorOutline), alphaMask);\n' +
			'}'
		);
	}

	public shader_scanOutline_Vert() {
		return (
			'precision lowp float;\n' +
			'varying vec3 vNormal, vPosition, vViewPosition;\n' +
			'uniform float vertexOffset;\n' +
			'uniform bool linesMode;\n' +
			'void main()\n' +
			'{\n' +
			'\tfloat scaleFix = 1.0;\n' +
			'\t\tif (linesMode) scaleFix = 100.0;\n' +
			'\tvNormal = normalize(normalMatrix * normal);\n' +
			'\tvPosition = position;\n' +
			'\tvViewPosition = (modelViewMatrix * vec4(position, 1.0)).xyz;\n' +
			'\t\n' +
			'\tvec4 vertexPosition = vec4(position + normal * (vec3(vertexOffset) * vec3(scaleFix)), 1.0);\n' +
			'\n' +
			'\tgl_Position = projectionMatrix * modelViewMatrix * vertexPosition;\n' +
			'}'
		);
	}

	public shader_bottom_Vert() {
		return (
			'precision lowp float;\n' +
			'varying vec3 vNormal; varying vec3 vPosition; varying vec3 vViewPosition;\n' +
			'\n' +
			'void main()\n' +
			'{\n' +
			'        vNormal = normalize(normalMatrix * normal);\n' +
			'        vPosition = position ;\n' +
			'        vViewPosition = (modelViewMatrix * vec4(position, 1.0)).xyz;\n' +
			'        \n' +
			'        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n' +
			'}'
		);
	}

	public shader_bottom_Frag() {
		return (
			'precision lowp float;\n' +
			'varying vec3 vNormal, vPosition, vViewPosition;\n' +
			'\n' +
			'void main()\n' +
			'    {\n' +
			'        vec3 viewPos = normalize(-vViewPosition.xyz);\n' +
			'\n' +
			'\t\tvec3 color1 = vec3(0.2) ;\n' +
			'\t\tvec3 color2 = vec3(0.7) ;\n' +
			'\t\tvec3 colorRimR = vec3(0.98, 0.9, 0.7) ;\n' +
			'\n' +
			'\t\tfloat blikWidth = 0.1 ;\n' +
			'\t\tfloat blikPowa = 2.0 ;\n' +
			'        \n' +
			'        //colorFill\n' +
			'        float colorMix = clamp(dot(vNormal + vec3(0.5, -1.1, 0.0), viewPos), 0.0, 1.0);\n' +
			'        vec3 colorFill = mix(color1, color2, colorMix );\n' +
			'\t\tfloat rimLight = clamp(dot(vNormal.x , 1.0 - vNormal.z ), 0.0, 1.0) ;\n' +
			'\t\t\n' +
			'\t\t//colorFill += vNormal.x / 2.0 ;\n' +
			'\t\tcolorFill += vec3(clamp(dot(vNormal, viewPos) - (1.0 - blikWidth), 0.0, 1.0)) * blikPowa ;\n' +
			'\t\tcolorFill += ( vec3(pow(rimLight, 3.0)) * colorRimR );\n' +
			'      \n' +
			'\n' +
			'\t\tgl_FragColor = vec4(vec3(colorFill), 1.0);\n' +
			'\n' +
			'    }'
		);
	}
}
